import type { WithHTMLAttrs } from "@scripts/react/util/dom";

import { type ApplyKlassNullable, klass } from "../util/classnames";

export const UnsafeContent = (props: ApplyKlassNullable<WithHTMLAttrs<{ content: string }>>) =>
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={{ __html: props.content }} {...klass(props.klass)} />
;
